import React from "react";
import { HelmetProvider } from "react-helmet-async";
import "./App.scss";
import Config from "config/Config";

function App() {
  return (
    <HelmetProvider>
      <div className="App font-montserrat">
        <Config />
      </div>
    </HelmetProvider>
  );
}

export default App;
